import { render, staticRenderFns } from "./selectedProperty.vue?vue&type=template&id=5db04920&"
import script from "./selectedProperty.vue?vue&type=script&lang=js&"
export * from "./selectedProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports